export default __webpack_public_path__ + "static/font-63cea40fba97f15931bf7d7b8a233c48.woff";